import Lenis from 'lenis';
import { gsap } from './gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let lenis = null;

/** Avvia Lenis e lo sincronizza con il ticker di GSAP/ScrollTrigger. Chiamare una volta, in App. */
export function startLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ duration: 1.1, smoothWheel: true });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);
  return lenis;
}

export function stopLenis() {
  if (!lenis) return;
  lenis.destroy();
  lenis = null;
}

export function getLenis() {
  return lenis;
}
